// extracted by mini-css-extract-plugin
export default {"base":"WarningMessage_base__ZrHs8"};